export const getAggregateFieldFromESResponse = (dataObj = {}, fieldName) => {
    let value = "NA";
    const buckets = dataObj["buckets"];
    const bucket = buckets?.length > 0 ? buckets[0] : {};
    if(bucket[fieldName] && bucket[fieldName].value) {
        value = bucket[fieldName].value;
    }
    return value;
}

export const validateSystemNotificationsOnboardingForm = (inputName, input, errorMap, setErrorMap) => {
    let errorMessage = "";
    switch(inputName){
        case "teamId":
            if(input.length > 50)
                errorMessage = "Team ID should not exceed 50 characters.";
            setErrorMap({
                ...errorMap,
                "teamId": errorMessage
            });
        break;
        case "consumerId":
            if(input.length > 100)
                errorMessage = "Consumer ID should not exceed 100 characters.";
            setErrorMap({
                ...errorMap,
                "consumerId": errorMessage
            });
        break;
    }
}

export const isValidSystemNotificationsOnboardingSubmission = (errorMap) => {
    for(let key of Object.keys(errorMap)) {
        if(errorMap[key] !== "") return false;
    }
    return true;
}
